import PropTypes from 'prop-types';
import React from 'react';
import InstructionsView from 'components/tools/InstructionsView';

const Instructions = ({nextView}) => <InstructionsView
  onSubmit={nextView}
  title='tools.split.tool.description'
  remember={[
    'tools.remember.account.physical',
    'tools.split.special.characters',
    'tools.split.system.address',
    'tools.split.before.split',
  ]}
  instructions={[
    {
      title: 'tools.instructions.run.report',
      body: 'tools.split.click.start',
    },
    {
      title: 'tools.instructions.review.report',
      body: 'tools.split.list.all',
    },
    {
      title: 'tools.split.confirm.split',
      body: 'tools.split.confirm.description',
    },
  ]}
  confirmTwice={false}
/>;

Instructions.propTypes = {
  nextView: PropTypes.func.isRequired,
};

export default Instructions;
